import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface ImageUploadOverlayProps {
  active: boolean;
  progress: number;
  fileName?: string;
}

const ImageUploadOverlay: React.FC<ImageUploadOverlayProps> = ({
  active,
  progress,
  fileName,
}) => {
  useEffect(() => {
    if (document.getElementById('image-upload-overlay-styles')) return;
    const style = document.createElement('style');
    style.id = 'image-upload-overlay-styles';
    style.textContent = '@keyframes imageUploadSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }, []);

  if (!active) return null;

  const safeProgress = Math.max(0, Math.min(100, progress));

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        zIndex: 30,
        borderRadius: '8px',
        pointerEvents: 'none',
      }}
    >
      <Loader2
        size={28}
        color="#2563eb"
        style={{ animation: 'imageUploadSpin 1s linear infinite' }}
      />
      <div style={{ textAlign: 'center', maxWidth: '80%' }}>
        <p style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: '#1f2937' }}>
          Uploading image… {safeProgress}%
        </p>
        {fileName && (
          <p style={{
            margin: '4px 0 0',
            fontSize: '12px',
            color: '#6b7280',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          >
            {fileName}
          </p>
        )}
      </div>
      <div style={{
        width: 'min(240px, 70%)',
        height: '6px',
        backgroundColor: '#e5e7eb',
        borderRadius: '999px',
        overflow: 'hidden',
      }}
      >
        <div style={{
          width: `${safeProgress}%`,
          height: '100%',
          backgroundColor: '#2563eb',
          transition: 'width 0.15s ease',
        }}
        />
      </div>
    </div>
  );
};

export default ImageUploadOverlay;
